import { Box } from '@mui/material';
import { ColDef } from '@siloreal:modules:private/silobag-list/config/extra/types';
import { FALLBACK_STRING, FieldCellStack, FieldPrimaryText, MetaRow } from './column-field-ui';
import * as HOOKS from '@siloreal:shared:hooks';

type SpeciesCellProps = {
  species?: {
    id: number;
    name: string;
    image_url?: string | null;
  } | null;
  variety?: string | null;
};

export function buildSpeciesColumn(): ColDef {
  const i18n = HOOKS.useLocale.getState();
  return {
    field: 'silobag_species_type_id',
    headerName: i18n.t('temp.common.specie'),
    minWidth: 196,
    flex: 1,
    renderCell: (params) => (
      <SpeciesCell species={params.row.silobag_species_types} variety={params.row.variety} />
    ),
  };
}

function SpeciesCell({ species, variety }: SpeciesCellProps) {
  const hasVariety = Boolean(variety?.trim());
  const speciesName = species?.name?.trim() || FALLBACK_STRING;
  const varietyName = variety?.trim() || FALLBACK_STRING;
  const speciesIcon = species?.image_url?.trim() || undefined;
  const i18n = HOOKS.useLocale();

  return (
    <FieldCellStack>
      {speciesIcon ? <SpeciesIcon src={speciesIcon} alt={speciesName} /> : null}
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <FieldPrimaryText title={speciesName}>{speciesName}</FieldPrimaryText>

        <MetaRow
          tag="VAR."
          disabled={!hasVariety}
          valueTitle={hasVariety ? varietyName : i18n.t('temp.common.specie_unavailable')}
        >
          {varietyName}
        </MetaRow>
      </Box>
    </FieldCellStack>
  );
}

function SpeciesIcon({ src, alt }: { src: string; alt: string }) {
  return (
    <Box
      component="img"
      src={src}
      alt={alt}
      title={alt}
      sx={{
        width: 28,
        height: 28,
        display: 'block',
        flexShrink: 0,
        filter: 'drop-shadow(0 1px 2px rgba(58,52,64,0.1))',
      }}
    />
  );
}
